import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import adapter from 'webrtc-adapter';

import './styles/global.scss';
import './assets/fonts/fonts.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
